import { render, staticRenderFns } from "./radio-button.vue?vue&type=template&id=8b230cbe&scoped=true"
import script from "./radio-button.vue?vue&type=script&lang=ts"
export * from "./radio-button.vue?vue&type=script&lang=ts"
import style0 from "./radio-button.vue?vue&type=style&index=0&id=8b230cbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b230cbe",
  null
  
)

export default component.exports